import { makeStyles, Theme, createStyles } from '@material-ui/core';

const useStyles = makeStyles((theme: Theme) => {
  return createStyles({
    box: {
      display: 'flex',
      alignItems: 'center',
      alignContent: 'center',
      justifyContent: 'center',
      height: '100vh',
      width: '100vw',
    },
    container: {
      padding: theme.spacing(6),
    },
    button: {
      backgroundColor: theme.palette.common.white,
      padding: theme.spacing(1, 4),
    },
    title: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      alignContent: 'center',
      justifyContent: 'center',
      padding: theme.spacing(3),
    },
    lockIcon: {
      width: theme.spacing(8),
      height: theme.spacing(8),
      padding: theme.spacing(2),
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      borderRadius: '100%',
      backgroundColor: theme.palette.error.light,
    },
    logIn: {
      marginTop: theme.spacing(1),
      marginBottom: theme.spacing(3),
    },
  });
});

export default useStyles;
